import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider,TextField, Grid, Typography, Box,CircularProgress } from "@mui/material"

import {getProductStruct, setData} from './ProductStruct'
import { updateTextValue, handleSubmit,updateValue,updateSelectedValue} from '../../core/js/FormUtils'
import {createAPI, updateAPI, getAPI, updateEditableAPI} from './ProductAPI';
import {CoreContext} from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {validMobileNumberEntry, validNameEntry, validEmailEntry} from '../../core/js/FormValidation';

import {getPathVariable} from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch,useSelector } from 'react-redux';
import { updateProductObj,addProductObj, setShowEditForProduct} from 'store/slice/PharmaSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';



export default function ProductEditForm(){
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getProductStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const {productDashboard} = useSelector((state)=>state.pharmaslice);
    const [productId, setProductId] = useState(productDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)
        
    const {phproductstatusList} = useSelector((state)=>state.pharmaslice);
    const handleDynamicSelectedValueForstatusid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'statusname', e.target.value==0?'Select Item':phproductstatusList.find(obj => obj.id === e.target.value).title);
    }    
    const {phproductformList} = useSelector((state)=>state.pharmaslice);
    const handleDynamicSelectedValueForformid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'formname', e.target.value==0?'Select Item':phproductformList.find(obj => obj.id === e.target.value).title);
    }    
    const {phpackagingmaterialList} = useSelector((state)=>state.pharmaslice);
    const handleDynamicSelectedValueForpackagingtypeid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'packagingtypename', e.target.value==0?'Select Item':phpackagingmaterialList.find(obj => obj.id === e.target.value).title);
    }    
    const {phproductshapeList} = useSelector((state)=>state.pharmaslice);
    const handleDynamicSelectedValueForshapeid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'shapename', e.target.value==0?'Select Item':phproductshapeList.find(obj => obj.id === e.target.value).title);
    }    
    const {packagingsizeList} = useSelector((state)=>state.pharmaslice);
    const handleDynamicSelectedValueForpackagingsize1id = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'packagingsize1name', e.target.value==0?'Select Item':packagingsizeList.find(obj => obj.id === e.target.value).title);
    }    
    const {pharmasetList} = useSelector((state)=>state.pharmaslice);
    const handleDynamicSelectedValueForsetid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'setname', e.target.value==0?'Select Item':pharmasetList.find(obj => obj.id === e.target.value).title);
    }    
    const {gstList} = useSelector((state)=>state.pharmaslice);
    const handleDynamicSelectedValueForgstid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'gstname', e.target.value==0?'Select Item':gstList.find(obj => obj.id === e.target.value).title);
    }

    const {apiInProgress} = useSelector((state)=>state.headerslice)
    useEffect(()=>{
    },[apiInProgress])

    useEffect(() => {
        if (productId!==-1) {
            if (dataLoaded) return;
            getAPI(productId, loadForm);
        }
        else {
           // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }
        })
    },[]);

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data)=>{
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value+" == "+getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value ) 
            return "yes"
        else 
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value ==="yes") 
            return true
        else 
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) =>{
        setShowError(false);
        
       if (validNameEntry(e))
        updateTextValue(formValues, setFormValues,e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);
        
       if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);
        
       if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }

    const createSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(addProductObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForProduct(false));
    }
    const updateSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(updateProductObj(obj));
        setNotification('Record with id['+productId+'] has been updated successfully !!!');
        dispatch(setShowEditForProduct(false));
        
    }
    const failuerCallback = (errorMsg) => {
         dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id,formValues, updateSuccessCallback, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        updateAPI(id,formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit=(e)=>{
        handleSubmit(e,productId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);
        
        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr =date.getFullYear()+ "-" +  monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form  noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError? <Alert severity="error">{errorMsg}</Alert>: ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{overflowY: "scroll", backgroundColor:'white',maxHeight:'58vh'}}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{productId===-1?'Add':'Edit'} Product </Typography>
                                <Divider/>
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center"> 
                                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.partyid.placeholder}
                                    required={formValues.partyid.required}
                                    label={formValues.partyid.label}
                                    name={formValues.partyid.name}
                                    value={formValues.partyid.value}
                                    onChange={handleTextChange}
                                    error={formValues.partyid.error}
                                    helperText={formValues.partyid.error && formValues.partyid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.businessid.placeholder}
                                    required={formValues.businessid.required}
                                    label={formValues.businessid.label}
                                    name={formValues.businessid.name}
                                    value={formValues.businessid.value}
                                    onChange={handleTextChange}
                                    error={formValues.businessid.error}
                                    helperText={formValues.businessid.error && formValues.businessid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.designvendorname.placeholder}
                                    required={formValues.designvendorname.required}
                                    label={formValues.designvendorname.label}
                                    name={formValues.designvendorname.name}
                                    value={formValues.designvendorname.value}
                                    onChange={handleTextChange}
                                    error={formValues.designvendorname.error}
                                    helperText={formValues.designvendorname.error && formValues.designvendorname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.designdispatched.label}
                            fieldName={formValues.designdispatched.name}
                            defaultValue={formValues.designdispatched.value}
                            errStr={formValues.designdispatched.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                   
                            <Grid item lg={4} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.shapeid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.shapeid.label}
                                            name={formValues.shapeid.name}
                                            value={formValues.shapeid.value}
                                            onChange={handleDynamicSelectedValueForshapeid}
                                            
                                            error={formValues.shapeid.error}
                                            helpertext={formValues.shapeid.error && formValues.shapeid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                phproductshapeList && phproductshapeList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>                        
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.shapename.placeholder}
                                    required={formValues.shapename.required}
                                    label={formValues.shapename.label}
                                    name={formValues.shapename.name}
                                    value={formValues.shapename.value}
                                    onChange={handleTextChange}
                                    error={formValues.shapename.error}
                                    helperText={formValues.shapename.error && formValues.shapename.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.formname.placeholder}
                                    required={formValues.formname.required}
                                    label={formValues.formname.label}
                                    name={formValues.formname.name}
                                    value={formValues.formname.value}
                                    onChange={handleTextChange}
                                    error={formValues.formname.error}
                                    helperText={formValues.formname.error && formValues.formname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.statusname.placeholder}
                                    required={formValues.statusname.required}
                                    label={formValues.statusname.label}
                                    name={formValues.statusname.name}
                                    value={formValues.statusname.value}
                                    onChange={handleTextChange}
                                    error={formValues.statusname.error}
                                    helperText={formValues.statusname.error && formValues.statusname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.packagingtypename.placeholder}
                                    required={formValues.packagingtypename.required}
                                    label={formValues.packagingtypename.label}
                                    name={formValues.packagingtypename.name}
                                    value={formValues.packagingtypename.value}
                                    onChange={handleTextChange}
                                    error={formValues.packagingtypename.error}
                                    helperText={formValues.packagingtypename.error && formValues.packagingtypename.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.rmstatus.placeholder}
                                    required={formValues.rmstatus.required}
                                    label={formValues.rmstatus.label}
                                    name={formValues.rmstatus.name}
                                    value={formValues.rmstatus.value}
                                    onChange={handleTextChange}
                                    error={formValues.rmstatus.error}
                                    helperText={formValues.rmstatus.error && formValues.rmstatus.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                   
                            <Grid item lg={4} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.packagingsize1id.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.packagingsize1id.label}
                                            name={formValues.packagingsize1id.name}
                                            value={formValues.packagingsize1id.value}
                                            onChange={handleDynamicSelectedValueForpackagingsize1id}
                                            
                                            error={formValues.packagingsize1id.error}
                                            helpertext={formValues.packagingsize1id.error && formValues.packagingsize1id.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                packagingsizeList && packagingsizeList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>                        
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.packagingsize1name.placeholder}
                                    required={formValues.packagingsize1name.required}
                                    label={formValues.packagingsize1name.label}
                                    name={formValues.packagingsize1name.name}
                                    value={formValues.packagingsize1name.value}
                                    onChange={handleTextChange}
                                    error={formValues.packagingsize1name.error}
                                    helperText={formValues.packagingsize1name.error && formValues.packagingsize1name.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.packagingsize2id.placeholder}
                                    required={formValues.packagingsize2id.required}
                                    label={formValues.packagingsize2id.label}
                                    name={formValues.packagingsize2id.name}
                                    value={formValues.packagingsize2id.value}
                                    onChange={handleTextChange}
                                    error={formValues.packagingsize2id.error}
                                    helperText={formValues.packagingsize2id.error && formValues.packagingsize2id.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.packagingsize2name.placeholder}
                                    required={formValues.packagingsize2name.required}
                                    label={formValues.packagingsize2name.label}
                                    name={formValues.packagingsize2name.name}
                                    value={formValues.packagingsize2name.value}
                                    onChange={handleTextChange}
                                    error={formValues.packagingsize2name.error}
                                    helperText={formValues.packagingsize2name.error && formValues.packagingsize2name.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                   
                            <Grid item lg={4} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.setid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.setid.label}
                                            name={formValues.setid.name}
                                            value={formValues.setid.value}
                                            onChange={handleDynamicSelectedValueForsetid}
                                            
                                            error={formValues.setid.error}
                                            helpertext={formValues.setid.error && formValues.setid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                pharmasetList && pharmasetList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>                        
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.setname.placeholder}
                                    required={formValues.setname.required}
                                    label={formValues.setname.label}
                                    name={formValues.setname.name}
                                    value={formValues.setname.value}
                                    onChange={handleTextChange}
                                    error={formValues.setname.error}
                                    helperText={formValues.setname.error && formValues.setname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.ctid.placeholder}
                                    required={formValues.ctid.required}
                                    label={formValues.ctid.label}
                                    name={formValues.ctid.name}
                                    value={formValues.ctid.value}
                                    onChange={handleTextChange}
                                    error={formValues.ctid.error}
                                    helperText={formValues.ctid.error && formValues.ctid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.qareferbackreason.placeholder}
                                    required={formValues.qareferbackreason.required}
                                    label={formValues.qareferbackreason.label}
                                    name={formValues.qareferbackreason.name}
                                    value={formValues.qareferbackreason.value}
                                    onChange={handleTextChange}
                                    error={formValues.qareferbackreason.error}
                                    helperText={formValues.qareferbackreason.error && formValues.qareferbackreason.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.designstatusqa.placeholder}
                                    required={formValues.designstatusqa.required}
                                    label={formValues.designstatusqa.label}
                                    name={formValues.designstatusqa.name}
                                    value={formValues.designstatusqa.value}
                                    onChange={handleTextChange}
                                    error={formValues.designstatusqa.error}
                                    helperText={formValues.designstatusqa.error && formValues.designstatusqa.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.rmorderedon.label}
                            fieldName={formValues.rmorderedon.name}
                            defaultValue={formValues.rmorderedon.value}
                            errStr={formValues.rmorderedon.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.rmreceivedon.label}
                            fieldName={formValues.rmreceivedon.name}
                            defaultValue={formValues.rmreceivedon.value}
                            errStr={formValues.rmreceivedon.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.designorderedon.label}
                            fieldName={formValues.designorderedon.name}
                            defaultValue={formValues.designorderedon.value}
                            errStr={formValues.designorderedon.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.designreceivedon.label}
                            fieldName={formValues.designreceivedon.name}
                            defaultValue={formValues.designreceivedon.value}
                            errStr={formValues.designreceivedon.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.brandname.placeholder}
                                    required={formValues.brandname.required}
                                    label={formValues.brandname.label}
                                    name={formValues.brandname.name}
                                    value={formValues.brandname.value}
                                    onChange={handleTextChange}
                                    error={formValues.brandname.error}
                                    helperText={formValues.brandname.error && formValues.brandname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                        <Grid item lg={4} xs={12}>
                            <RadioForBoolean 
                                label={formValues.repeatorder.label}
                                fieldName={formValues.repeatorder.name}
                                defaultValue={getRadioValue(formValues.repeatorder.value)}
                                handleChange={handleRadioChange}
                            /> 
                        </Grid><Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.designapprovaldate.label}
                            fieldName={formValues.designapprovaldate.name}
                            defaultValue={formValues.designapprovaldate.value}
                            errStr={formValues.designapprovaldate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.qadesignapprovaldate.label}
                            fieldName={formValues.qadesignapprovaldate.name}
                            defaultValue={formValues.qadesignapprovaldate.value}
                            errStr={formValues.qadesignapprovaldate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.qacompapprovaldate.label}
                            fieldName={formValues.qacompapprovaldate.name}
                            defaultValue={formValues.qacompapprovaldate.value}
                            errStr={formValues.qacompapprovaldate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.batchnumber.placeholder}
                                    required={formValues.batchnumber.required}
                                    label={formValues.batchnumber.label}
                                    name={formValues.batchnumber.name}
                                    value={formValues.batchnumber.value}
                                    onChange={handleTextChange}
                                    error={formValues.batchnumber.error}
                                    helperText={formValues.batchnumber.error && formValues.batchnumber.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.pmorderid.placeholder}
                                    required={formValues.pmorderid.required}
                                    label={formValues.pmorderid.label}
                                    name={formValues.pmorderid.name}
                                    value={formValues.pmorderid.value}
                                    onChange={handleTextChange}
                                    error={formValues.pmorderid.error}
                                    helperText={formValues.pmorderid.error && formValues.pmorderid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.rmorderid.placeholder}
                                    required={formValues.rmorderid.required}
                                    label={formValues.rmorderid.label}
                                    name={formValues.rmorderid.name}
                                    value={formValues.rmorderid.value}
                                    onChange={handleTextChange}
                                    error={formValues.rmorderid.error}
                                    helperText={formValues.rmorderid.error && formValues.rmorderid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                   
                            <Grid item lg={4} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.gstid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.gstid.label}
                                            name={formValues.gstid.name}
                                            value={formValues.gstid.value}
                                            onChange={handleDynamicSelectedValueForgstid}
                                            
                                            error={formValues.gstid.error}
                                            helpertext={formValues.gstid.error && formValues.gstid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                gstList && gstList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>                        
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.gstname.placeholder}
                                    required={formValues.gstname.required}
                                    label={formValues.gstname.label}
                                    name={formValues.gstname.name}
                                    value={formValues.gstname.value}
                                    onChange={handleTextChange}
                                    error={formValues.gstname.error}
                                    helperText={formValues.gstname.error && formValues.gstname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.inventorycharges.placeholder}
                                    required={formValues.inventorycharges.required}
                                    label={formValues.inventorycharges.label}
                                    name={formValues.inventorycharges.name}
                                    value={formValues.inventorycharges.value}
                                    onChange={handleTextChange}
                                    error={formValues.inventorycharges.error}
                                    helperText={formValues.inventorycharges.error && formValues.inventorycharges.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.cylindercharges.placeholder}
                                    required={formValues.cylindercharges.required}
                                    label={formValues.cylindercharges.label}
                                    name={formValues.cylindercharges.name}
                                    value={formValues.cylindercharges.value}
                                    onChange={handleTextChange}
                                    error={formValues.cylindercharges.error}
                                    helperText={formValues.cylindercharges.error && formValues.cylindercharges.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                        <Grid item lg={4} xs={12}>
                            <RadioForBoolean 
                                label={formValues.repeatproduct.label}
                                fieldName={formValues.repeatproduct.name}
                                defaultValue={getRadioValue(formValues.repeatproduct.value)}
                                handleChange={handleRadioChange}
                            /> 
                        </Grid>                        
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.repeatproductid.placeholder}
                                    required={formValues.repeatproductid.required}
                                    label={formValues.repeatproductid.label}
                                    name={formValues.repeatproductid.name}
                                    value={formValues.repeatproductid.value}
                                    onChange={handleTextChange}
                                    error={formValues.repeatproductid.error}
                                    helperText={formValues.repeatproductid.error && formValues.repeatproductid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.advance.placeholder}
                                    required={formValues.advance.required}
                                    label={formValues.advance.label}
                                    name={formValues.advance.name}
                                    value={formValues.advance.value}
                                    onChange={handleTextChange}
                                    error={formValues.advance.error}
                                    helperText={formValues.advance.error && formValues.advance.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.total.placeholder}
                                    required={formValues.total.required}
                                    label={formValues.total.label}
                                    name={formValues.total.name}
                                    value={formValues.total.value}
                                    onChange={handleDoubleChange}
                                    error={formValues.total.error}
                                    helperText={formValues.total.error && formValues.total.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.totalwithgst.placeholder}
                                    required={formValues.totalwithgst.required}
                                    label={formValues.totalwithgst.label}
                                    name={formValues.totalwithgst.name}
                                    value={formValues.totalwithgst.value}
                                    onChange={handleDoubleChange}
                                    error={formValues.totalwithgst.error}
                                    helperText={formValues.totalwithgst.error && formValues.totalwithgst.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.assetname.placeholder}
                                    required={formValues.assetname.required}
                                    label={formValues.assetname.label}
                                    name={formValues.assetname.name}
                                    value={formValues.assetname.value}
                                    onChange={handleTextChange}
                                    error={formValues.assetname.error}
                                    helperText={formValues.assetname.error && formValues.assetname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.assetpath.placeholder}
                                    required={formValues.assetpath.required}
                                    label={formValues.assetpath.label}
                                    name={formValues.assetpath.name}
                                    value={formValues.assetpath.value}
                                    onChange={handleTextChange}
                                    error={formValues.assetpath.error}
                                    helperText={formValues.assetpath.error && formValues.assetpath.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.assetid.placeholder}
                                    required={formValues.assetid.required}
                                    label={formValues.assetid.label}
                                    name={formValues.assetid.name}
                                    value={formValues.assetid.value}
                                    onChange={handleTextChange}
                                    error={formValues.assetid.error}
                                    helperText={formValues.assetid.error && formValues.assetid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.pmreceivedon.label}
                            fieldName={formValues.pmreceivedon.name}
                            defaultValue={formValues.pmreceivedon.value}
                            errStr={formValues.pmreceivedon.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.qaassetid.placeholder}
                                    required={formValues.qaassetid.required}
                                    label={formValues.qaassetid.label}
                                    name={formValues.qaassetid.name}
                                    value={formValues.qaassetid.value}
                                    onChange={handleTextChange}
                                    error={formValues.qaassetid.error}
                                    helperText={formValues.qaassetid.error && formValues.qaassetid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.qaassetname.placeholder}
                                    required={formValues.qaassetname.required}
                                    label={formValues.qaassetname.label}
                                    name={formValues.qaassetname.name}
                                    value={formValues.qaassetname.value}
                                    onChange={handleTextChange}
                                    error={formValues.qaassetname.error}
                                    helperText={formValues.qaassetname.error && formValues.qaassetname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.qaassetpath.placeholder}
                                    required={formValues.qaassetpath.required}
                                    label={formValues.qaassetpath.label}
                                    name={formValues.qaassetpath.name}
                                    value={formValues.qaassetpath.value}
                                    onChange={handleTextChange}
                                    error={formValues.qaassetpath.error}
                                    helperText={formValues.qaassetpath.error && formValues.qaassetpath.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.comptype.placeholder}
                                    required={formValues.comptype.required}
                                    label={formValues.comptype.label}
                                    name={formValues.comptype.name}
                                    value={formValues.comptype.value}
                                    onChange={handleTextChange}
                                    error={formValues.comptype.error}
                                    helperText={formValues.comptype.error && formValues.comptype.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.packagingtext.placeholder}
                                    required={formValues.packagingtext.required}
                                    label={formValues.packagingtext.label}
                                    name={formValues.packagingtext.name}
                                    value={formValues.packagingtext.value}
                                    onChange={handleTextChange}
                                    error={formValues.packagingtext.error}
                                    helperText={formValues.packagingtext.error && formValues.packagingtext.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.liquidcolor.placeholder}
                                    required={formValues.liquidcolor.required}
                                    label={formValues.liquidcolor.label}
                                    name={formValues.liquidcolor.name}
                                    value={formValues.liquidcolor.value}
                                    onChange={handleTextChange}
                                    error={formValues.liquidcolor.error}
                                    helperText={formValues.liquidcolor.error && formValues.liquidcolor.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.manufdate.label}
                            fieldName={formValues.manufdate.name}
                            defaultValue={formValues.manufdate.value}
                            errStr={formValues.manufdate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.overallstatusid.placeholder}
                                    required={formValues.overallstatusid.required}
                                    label={formValues.overallstatusid.label}
                                    name={formValues.overallstatusid.name}
                                    value={formValues.overallstatusid.value}
                                    onChange={handleTextChange}
                                    error={formValues.overallstatusid.error}
                                    helperText={formValues.overallstatusid.error && formValues.overallstatusid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.approvaldate.label}
                            fieldName={formValues.approvaldate.name}
                            defaultValue={formValues.approvaldate.value}
                            errStr={formValues.approvaldate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.submissiondate.label}
                            fieldName={formValues.submissiondate.name}
                            defaultValue={formValues.submissiondate.value}
                            errStr={formValues.submissiondate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.deliverydate.label}
                            fieldName={formValues.deliverydate.name}
                            defaultValue={formValues.deliverydate.value}
                            errStr={formValues.deliverydate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.cancelleddate.label}
                            fieldName={formValues.cancelleddate.name}
                            defaultValue={formValues.cancelleddate.value}
                            errStr={formValues.cancelleddate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.mrptext.placeholder}
                                    required={formValues.mrptext.required}
                                    label={formValues.mrptext.label}
                                    name={formValues.mrptext.name}
                                    value={formValues.mrptext.value}
                                    onChange={handleTextChange}
                                    error={formValues.mrptext.error}
                                    helperText={formValues.mrptext.error && formValues.mrptext.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.reasondate.label}
                            fieldName={formValues.reasondate.name}
                            defaultValue={formValues.reasondate.value}
                            errStr={formValues.reasondate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.reason.placeholder}
                                    required={formValues.reason.required}
                                    label={formValues.reason.label}
                                    name={formValues.reason.name}
                                    value={formValues.reason.value}
                                    onChange={handleTextChange}
                                    error={formValues.reason.error}
                                    helperText={formValues.reason.error && formValues.reason.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.monthtagid.placeholder}
                                    required={formValues.monthtagid.required}
                                    label={formValues.monthtagid.label}
                                    name={formValues.monthtagid.name}
                                    value={formValues.monthtagid.value}
                                    onChange={handleTextChange}
                                    error={formValues.monthtagid.error}
                                    helperText={formValues.monthtagid.error && formValues.monthtagid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.prestatusid.placeholder}
                                    required={formValues.prestatusid.required}
                                    label={formValues.prestatusid.label}
                                    name={formValues.prestatusid.name}
                                    value={formValues.prestatusid.value}
                                    onChange={handleTextChange}
                                    error={formValues.prestatusid.error}
                                    helperText={formValues.prestatusid.error && formValues.prestatusid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.biltyid.placeholder}
                                    required={formValues.biltyid.required}
                                    label={formValues.biltyid.label}
                                    name={formValues.biltyid.name}
                                    value={formValues.biltyid.value}
                                    onChange={handleTextChange}
                                    error={formValues.biltyid.error}
                                    helperText={formValues.biltyid.error && formValues.biltyid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.executiveid.placeholder}
                                    required={formValues.executiveid.required}
                                    label={formValues.executiveid.label}
                                    name={formValues.executiveid.name}
                                    value={formValues.executiveid.value}
                                    onChange={handleTextChange}
                                    error={formValues.executiveid.error}
                                    helperText={formValues.executiveid.error && formValues.executiveid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.partyname.placeholder}
                                    required={formValues.partyname.required}
                                    label={formValues.partyname.label}
                                    name={formValues.partyname.name}
                                    value={formValues.partyname.value}
                                    onChange={handleTextChange}
                                    error={formValues.partyname.error}
                                    helperText={formValues.partyname.error && formValues.partyname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.orderid.placeholder}
                                    required={formValues.orderid.required}
                                    label={formValues.orderid.label}
                                    name={formValues.orderid.name}
                                    value={formValues.orderid.value}
                                    onChange={handleTextChange}
                                    error={formValues.orderid.error}
                                    helperText={formValues.orderid.error && formValues.orderid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.title.placeholder}
                                    required={formValues.title.required}
                                    label={formValues.title.label}
                                    name={formValues.title.name}
                                    value={formValues.title.value}
                                    onChange={handleTextChange}
                                    error={formValues.title.error}
                                    helperText={formValues.title.error && formValues.title.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.amount.placeholder}
                                    required={formValues.amount.required}
                                    label={formValues.amount.label}
                                    name={formValues.amount.name}
                                    value={formValues.amount.value}
                                    onChange={handleDoubleChange}
                                    error={formValues.amount.error}
                                    helperText={formValues.amount.error && formValues.amount.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                    
                <Grid item lg={4} xs={12} sx={{ width:'100%' }}>
                    <FormControl sx={{  width:'100%'}} size="Normal">
                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.executivename.label}</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            label={formValues.executivename.label}
                            name={formValues.executivename.name}
                            value={formValues.executivename.value}
                            onChange={handleTextChange}
                            
                            error={formValues.executivename.error}
                            helperText={formValues.executivename.error && formValues.executivename.errorMessage}
                            >
                            
								<MenuItem value="EXEC 1">EXEC 1</MenuItem>
								<MenuItem value="EXEC 2">EXEC 2</MenuItem>
								<MenuItem value="EXEC 3">EXEC 3</MenuItem>
								<MenuItem value="EXEC 4">EXEC 4</MenuItem>
								<MenuItem value="EXEC 5">EXEC 5</MenuItem>
                        </Select>
                    </FormControl> 
                </Grid><Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.dispatchdate.label}
                            fieldName={formValues.dispatchdate.name}
                            defaultValue={formValues.dispatchdate.value}
                            errStr={formValues.dispatchdate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                   
                            <Grid item lg={4} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.packagingtypeid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.packagingtypeid.label}
                                            name={formValues.packagingtypeid.name}
                                            value={formValues.packagingtypeid.value}
                                            onChange={handleDynamicSelectedValueForpackagingtypeid}
                                            
                                            error={formValues.packagingtypeid.error}
                                            helpertext={formValues.packagingtypeid.error && formValues.packagingtypeid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                phpackagingmaterialList && phpackagingmaterialList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>                
                <Grid item lg={4} xs={12} sx={{ width:'100%' }}>
                    <FormControl sx={{  width:'100%'}} size="Normal">
                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.batchpackaging.label}</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            label={formValues.batchpackaging.label}
                            name={formValues.batchpackaging.name}
                            value={formValues.batchpackaging.value}
                            onChange={handleTextChange}
                            
                            error={formValues.batchpackaging.error}
                            helperText={formValues.batchpackaging.error && formValues.batchpackaging.errorMessage}
                            >
                            
								<MenuItem value="ALU ALU">ALU ALU</MenuItem>
								<MenuItem value="BLISTER">BLISTER</MenuItem>
								<MenuItem value="DROP">DROP</MenuItem>
								<MenuItem value="BOTTLE">BOTTLE</MenuItem>
								<MenuItem value="JAR">JAR</MenuItem>
								<MenuItem value="LONG STRIP">LONG STRIP</MenuItem>
								<MenuItem value="METALIC CRTN">METALIC CRTN</MenuItem>
                        </Select>
                    </FormControl> 
                </Grid>                        
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.batchsize.placeholder}
                                    required={formValues.batchsize.required}
                                    label={formValues.batchsize.label}
                                    name={formValues.batchsize.name}
                                    value={formValues.batchsize.value}
                                    onChange={handleTextChange}
                                    error={formValues.batchsize.error}
                                    helperText={formValues.batchsize.error && formValues.batchsize.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                    
                <Grid item lg={4} xs={12} sx={{ width:'100%' }}>
                    <FormControl sx={{  width:'100%'}} size="Normal">
                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.designstatus.label}</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            label={formValues.designstatus.label}
                            name={formValues.designstatus.name}
                            value={formValues.designstatus.value}
                            onChange={handleTextChange}
                            
                            error={formValues.designstatus.error}
                            helperText={formValues.designstatus.error && formValues.designstatus.errorMessage}
                            >
                            
								<MenuItem value="DESIGNING">DESIGNING</MenuItem>
								<MenuItem value="APPROVAL_PENDING">APPROVAL_PENDING</MenuItem>
								<MenuItem value="APPROVED">APPROVED</MenuItem>
                        </Select>
                    </FormControl> 
                </Grid>               
                            <Grid item lg={4} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.formid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.formid.label}
                                            name={formValues.formid.name}
                                            value={formValues.formid.value}
                                            onChange={handleDynamicSelectedValueForformid}
                                            
                                            error={formValues.formid.error}
                                            helpertext={formValues.formid.error && formValues.formid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                phproductformList && phproductformList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>               
                            <Grid item lg={4} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.statusid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.statusid.label}
                                            name={formValues.statusid.name}
                                            value={formValues.statusid.value}
                                            onChange={handleDynamicSelectedValueForstatusid}
                                            
                                            error={formValues.statusid.error}
                                            helpertext={formValues.statusid.error && formValues.statusid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                phproductstatusList && phproductstatusList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid><Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.expirydate.label}
                            fieldName={formValues.expirydate.name}
                            defaultValue={formValues.expirydate.value}
                            errStr={formValues.expirydate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.foillabel.placeholder}
                                    required={formValues.foillabel.required}
                                    label={formValues.foillabel.label}
                                    name={formValues.foillabel.name}
                                    value={formValues.foillabel.value}
                                    onChange={handleTextChange}
                                    error={formValues.foillabel.error}
                                    helperText={formValues.foillabel.error && formValues.foillabel.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.packaging.placeholder}
                                    required={formValues.packaging.required}
                                    label={formValues.packaging.label}
                                    name={formValues.packaging.name}
                                    value={formValues.packaging.value}
                                    onChange={handleTextChange}
                                    error={formValues.packaging.error}
                                    helperText={formValues.packaging.error && formValues.packaging.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.rate.placeholder}
                                    required={formValues.rate.required}
                                    label={formValues.rate.label}
                                    name={formValues.rate.name}
                                    value={formValues.rate.value}
                                    onChange={handleDoubleChange}
                                    error={formValues.rate.error}
                                    helperText={formValues.rate.error && formValues.rate.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.mrp.placeholder}
                                    required={formValues.mrp.required}
                                    label={formValues.mrp.label}
                                    name={formValues.mrp.name}
                                    value={formValues.mrp.value}
                                    onChange={handleDoubleChange}
                                    error={formValues.mrp.error}
                                    helperText={formValues.mrp.error && formValues.mrp.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                    <Grid item lg={3} xs={12}>
    <MyDate 
                            label={formValues.podate.label}
                            fieldName={formValues.podate.name}
                            defaultValue={formValues.podate.value}
                            errStr={formValues.podate.errorMessage}
                            setDate={setDate} 
    />
</Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.packagingremarks.placeholder}
                                    required={formValues.packagingremarks.required}
                                    label={formValues.packagingremarks.label}
                                    name={formValues.packagingremarks.name}
                                    value={formValues.packagingremarks.value}
                                    onChange={handleTextChange}
                                    error={formValues.packagingremarks.error}
                                    helperText={formValues.packagingremarks.error && formValues.packagingremarks.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.dispatchedsize.placeholder}
                                    required={formValues.dispatchedsize.required}
                                    label={formValues.dispatchedsize.label}
                                    name={formValues.dispatchedsize.name}
                                    value={formValues.dispatchedsize.value}
                                    onChange={handleTextChange}
                                    error={formValues.dispatchedsize.error}
                                    helperText={formValues.dispatchedsize.error && formValues.dispatchedsize.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                    
                <Grid item lg={4} xs={12} sx={{ width:'100%' }}>
                    <FormControl sx={{  width:'100%'}} size="Normal">
                        <InputLabel id="demo-simple-select-autowidth-label">{formValues.cr_cash.label}</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            label={formValues.cr_cash.label}
                            name={formValues.cr_cash.name}
                            value={formValues.cr_cash.value}
                            onChange={handleTextChange}
                            
                            error={formValues.cr_cash.error}
                            helperText={formValues.cr_cash.error && formValues.cr_cash.errorMessage}
                            >
                            
								<MenuItem value="CREDIT">CREDIT</MenuItem>
								<MenuItem value="CASH">CASH</MenuItem>
                        </Select>
                    </FormControl> 
                </Grid>                        
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.remarks.placeholder}
                                    required={formValues.remarks.required}
                                    label={formValues.remarks.label}
                                    name={formValues.remarks.name}
                                    value={formValues.remarks.value}
                                    onChange={handleTextChange}
                                    error={formValues.remarks.error}
                                    helperText={formValues.remarks.error && formValues.remarks.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                        
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%',  }}
                                        />
                                    </Grid> 
                                </Grid>
                            :<></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider/>
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                {   apiInProgress?<CircularProgress/>:
                    <>
                        <Button variant="outlined" type="submit" >{productId===-1?'Add':'Save'}</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="outlined" onClick={()=>{dispatch(setShowEditForProduct(false));}}>Close</Button>
                    </>
                }
                </Grid>
            </Grid>
        </form>
    );
};